import DonationDeleteForm from '@/core/components/forms/DonationDeleteForm/DonationDeleteForm';

export default DonationDeleteForm;
